import Dialog from "../../atoms/dialog";
import { makeStyles } from "@material-ui/core";
import CreateTemplate from "./CreateTemplate";

const useStyles = makeStyles(theme => {
    return {
        textCapitalise: {
            textTransform: 'capitalize'
        }
    }
})

const CreateTemplateDialog = (props) => {
    const { onCompletion, onClose } = props;
    const classes = useStyles();

    const handleClose = () => {
        onClose();
    }

    return (

        <Dialog
            title={"Import Clusterlet Templates"}
            open={true}
            handleClose={handleClose}
            className={classes.textCapitalise}
        >

            <CreateTemplate onCompletion={onCompletion} onClose={onClose} textCapitalise={classes.textCapitalise} />

        </Dialog >
    )
}

export default CreateTemplateDialog;